import { ChevronDown, ChevronUp, ChevronsUpDown, Funnel } from "lucide-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";
import { IUseLimitsFilterFormData } from "../../../containers/FunctionManagementPage";
import { FeatureTypes } from "../../../models/featureUseLimits/FeatureUseLimitsData.const";
import ColumnTextFilterPopover from "../../FacilityListComponents/RefactoredFacilityTable/ColumnTextFilterPopover";

export interface IFunctionListProps {
  targetType: FeatureTypes;
  filterFormData: IUseLimitsFilterFormData;
  onChangeFilterFormData: (filterFormData: IUseLimitsFilterFormData) => void;
  onClickFilter: () => void;
}

export const IndividualSettingListHeader: React.FunctionComponent<
  IFunctionListProps
> = ({ targetType, filterFormData, onChangeFilterFormData, onClickFilter }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`functionManagementPage.functionList.${key}`);

  const [showNameFilter, setShowNameFilter] = useState<boolean>(false);

  const isSortedByName = filterFormData.sort === "name";
  const sortOrder = filterFormData.order;

  const onClickSortByName = () => {
    onChangeFilterFormData({
      ...filterFormData,
      sort: "name",
      order: isSortedByName && sortOrder === "asc" ? "desc" : "asc",
      pageIndex: 1,
    });
  };

  const hasActiveFeatureFilter = filterFormData.useLimitsStatus.some(
    (item) => item.can_use !== undefined
  );

  return (
    <div className="row-th function-individual-settings-list-header">
      <div className="col-th name">
        <div className="header-cell-inner">
          <button
            type="button"
            className={`individual-setting-sort-button ${
              isSortedByName ? "active" : ""
            }`}
            onClick={onClickSortByName}
          >
            <span>{_t(`functionManagementPage.${targetType}`)}</span>
            <span
              className={`sort-icon-wrap ${
                isSortedByName ? "is-active" : "is-idle"
              }`}
              aria-hidden="true"
            >
              {isSortedByName ? (
                sortOrder === "desc" ? (
                  <ChevronDown className="sort-icon" size={14} strokeWidth={2} />
                ) : (
                  <ChevronUp className="sort-icon" size={14} strokeWidth={2} />
                )
              ) : (
                <ChevronsUpDown className="sort-icon" size={14} strokeWidth={2} />
              )}
            </span>
          </button>
          <div className="filter-trigger-wrap">
            <button
              type="button"
              className={`filter-trigger-btn ${
                filterFormData.searchKeyword ? "has-filter" : ""
              }`}
              onClick={(event) => {
                event.stopPropagation();
                setShowNameFilter((prev) => !prev);
              }}
              aria-label="filter-name"
            >
              <Funnel className="funnel-icon" size={14} strokeWidth={2} />
            </button>
            {showNameFilter && (
              <ColumnTextFilterPopover
                columnId="name"
                title={t(`placeholder.${targetType}`)}
                value={filterFormData.searchKeyword}
                onApply={(value) => {
                  onChangeFilterFormData({
                    ...filterFormData,
                    searchKeyword: value,
                    pageIndex: 1,
                  });
                }}
                onClear={() => {
                  onChangeFilterFormData({
                    ...filterFormData,
                    searchKeyword: "",
                    pageIndex: 1,
                  });
                }}
                onClose={() => setShowNameFilter(false)}
              />
            )}
          </div>
        </div>
      </div>
      <div className="col-th active-features">
        <div className="header-cell-inner">
          <span>{t("header.active_features")}</span>
          <div className="filter-trigger-wrap">
            <button
              type="button"
              className={`filter-trigger-btn ${
                hasActiveFeatureFilter ? "has-filter" : ""
              }`}
              onClick={onClickFilter}
              aria-label="filter-active-features"
            >
              <Funnel className="funnel-icon" size={14} strokeWidth={2} />
            </button>
          </div>
        </div>
      </div>
      <div className="col-th actions"></div>
    </div>
  );
};
